import "../css/index.scss";
import $ from "jquery/dist/jquery";

//import "bootstrap/dist/js/bootstrap.bundle";

import "@nxcms/nxcms-js/src/js/sentry";

import ScrollReveal from "scrollreveal";

import "@nxcms/nxcms-js/src/js/static/bootstrap_5";
import "@nxcms/nxcms-js/src/js/static";
import "@nxcms/nxcms-js/src/js/gdpr";

import "./currency";
import "./form-redirect";

window.jQuery = window.$ = $;

(function ($) {
  const navbar = document.getElementById("navbar");
  if (navbar) {
    window.onscroll = function () {
      if (window.scrollY > 1) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    };
  }

  const sr = ScrollReveal();

  $(".reveal").each(function () {
    const x = $(this);
    sr.reveal(this, {
      duration: parseInt(x.attr("data-reveal-duration") || 500),
      delay: parseInt(x.attr("data-reveal-delay") || 0),
      origin: x.attr("data-reveal-origin") || "bottom",
      distance: x.attr("data-reveal-distance") || "50px",
    });
  });
})($);
